import React from 'react';
import UserManagerComponent from '../components/UserManagerComponent';

function Users() {
    return (
        <div>
            <h1>Users</h1>
            <UserManagerComponent />
        </div>
    );
}

export default Users;
